import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["typing"]

    connect() {
        this.element.addEventListener("turbo:before-stream-render", this.handleStream.bind(this))
    }

    handleStream(event) {
        const stream = event.detail.newStream
        const template = stream.querySelector("template")

        // Check for explicit "done" signal
        if (template?.content?.querySelector("[data-streaming-complete]")) {
            this.streamingComplete()
            return
        }

        const targetId = stream.getAttribute("target")
        const action = stream.getAttribute("action")

        if (targetId?.includes("_content") && action === "append") {
            this.showTyping()
        }

        this.hideTypingDebounced()
    }

    showTyping() {
        this.typingTarget.classList.remove("hidden")
    }

    hideTyping() {
        this.typingTarget.classList.add("hidden")
    }

    streamingComplete() {
        if (this.hideTimeout) clearTimeout(this.hideTimeout)
        this.hideTyping()
        this.dispatch("streaming-finished")
    }

    hideTypingDebounced() {
        if (this.hideTimeout) clearTimeout(this.hideTimeout)
        this.hideTimeout = setTimeout(() => {
            this.streamingComplete()
        }, 3000) // Raised to 3s to account for tool calls
    }
}
